module.exports = __webpack_public_path__ + "static/media/ashColor1.ab9e0d4f.jpg";